import React from "react";
import { Button, Result, Space } from "antd";

/**
 * מסך הצלחה ב-Drawer בלבד — ללא Swal / modal מרכזי.
 */
export default function OperationRequestSuccessContent({
  displayOrderNumber,
  onGoToMyRequests,
  onClose,
}) {
  return (
    <Result
      status="success"
      title="הפנייה נשלחה לאופרציה"
      subTitle={
        displayOrderNumber
          ? displayOrderNumber === "כללי"
            ? "פנייה כללית (ללא הזמנה)"
            : `מספר הזמנה: ${displayOrderNumber}`
          : undefined
      }
      extra={
        <Space direction="vertical" style={{ width: "100%" }}>
          <Button type="primary" block onClick={onGoToMyRequests}>
            פתח בדוקט
          </Button>
          <Button block onClick={onClose}>
            סגור
          </Button>
        </Space>
      }
    />
  );
}
